<template>
  <div>
    <div class="c-box">
      <header class="c-box__heading" @click="toggleVariationInfo">
        <span v-once>{{ variationTitle() }}</span>
        <i v-bind:class="toggleIconClass()" class="u-floatRight"></i>
      </header>

      <div class="c-box__body" v-show="show">
        <div class="c-box__inner">
          <panel>
            <div class="l-row">
              <form-group :label="$t('gender.label')" :columns="4" :error="getErrorBySku('gender', variation.sku)">
                <select v-model="variation.gender" class="form-select">
                  <option value="null">
                    Selecione
                  </option>
                  <option value="male">
                    {{ $t('gender.male.label') }}
                  </option>
                  <option value="female">
                    {{ $t('gender.female.label') }}
                  </option>
                  <option value="unisex">
                    {{ $t('gender.unisex.label') }}
                  </option>
                </select>
              </form-group>

              <form-group :label="$t('crossDocking.label')" :columns="4"
                          :error="getErrorBySku('crossDocking', variation.sku)">
                <div class="form-flex">
                  <input class="form-input" type="text" v-model="variation.crossDocking">
                  <span class="form-addon">dias</span>
                </div>
              </form-group>

              <form-group :label="$t('manufacturerReference.label')" :columns="4"
                          :error="getErrorBySku('manufacturerReference', variation.sku)">
                <input class="form-input" type="text" v-model="variation.manufacturerReference">
              </form-group>

              <form-group label="EAN" :columns="4" :error="getErrorBySku('ean', variation.sku)">
                <input class="form-input" type="text" v-model="variation.ean">
              </form-group>

              <form-group :label="$t('quantity.label')" :columns="4" :error="getErrorBySku('quantity', variation.sku)">
                <input class="form-input" type="number" v-model="variation.quantity">
              </form-group>

              <form-group v-for="label in Object.keys(variation.attributes)" :label="$t(`${label}.label`)" :columns="4"
                          :error="getErrorBySku(label, variation.sku)">
                <input class="form-input" type="text" v-model="variation.attributes[label]">
              </form-group>

              <form-group label="Peso" :columns="4" :error="getErrorBySku('weight', variation.sku)" :required="true">
                <div class="form-flex">
                  <input class="form-input" type="text" v-model="variation.weight">
                  <span class="form-addon">g</span>
                </div>
              </form-group>

              <form-group label="Altura" :columns="4" :error="getErrorBySku('height', variation.sku)" :required="true">
                <div class="form-flex">
                  <input class="form-input" type="text" v-model="variation.height">
                  <span class="form-addon">cm</span>
                </div>
              </form-group>

              <form-group label="Largura" :columns="4" :error="getErrorBySku('width', variation.sku)" :required="true">
                <div class="form-flex">
                  <input class="form-input" type="text" v-model="variation.width">
                  <span class="form-addon">cm</span>
                </div>
              </form-group>

              <form-group label="Comprimento" :columns="4" :error="getErrorBySku('length', variation.sku)" :required="true">
                <div class="form-flex">
                  <input class="form-input" type="text" v-model="variation.length">
                  <span class="form-addon">cm</span>
                </div>
              </form-group>

            </div>

            <div class="l-row">
              <form-group label="Preço antigo" :columns="4" :error="getErrorBySku('previousPrice', variation.sku)" :required="true">
                <money v-model="variation.previousPrice" v-bind="money" class="form-input"/>
              </form-group>

              <form-group label="Preço atual" :columns="4" :error="getErrorBySku('currentPrice', variation.sku)" :required="true">
                <money v-model="variation.currentPrice" v-bind="money" class="form-input"/>
              </form-group>

            </div>

            <product-provide-image :variation="variation"></product-provide-image>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { mapGetters } from 'vuex'
  import { Container, Draggable } from 'vue-smooth-dnd'
  import Checkbox from '@/components/template/Checkbox'
  import Multiselect from 'vue-multiselect'
  import UploadFile from '@/components/template/UploadFile'
  import ProductProvideImage from '@/components/ProductProvide/Edit/Api/Image'
  import { Money } from 'v-money'

  export default {
    data: () => ({
      show: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      toggleVariationInfo () {
        if (this.show) {
          this.show = false
          return
        }

        this.show = true
      },
      toggleIconClass () {
        return {
          'icon-circle-up': this.show,
          'icon-circle-down': !this.show
        }
      },
      variationTitle () {
        const title = [`SKU: ${this.variation.sku}`]

        if (this.variation.ean !== null && this.variation.ean !== undefined && this.variation.ean !== '') {
          title.push(`EAN: ${this.variation.ean}`)
        }

        for (let i in Object.keys(this.variation.attributes)) {
          const name = Object.keys(this.variation.attributes)[i]
          const value = this.variation.attributes[name]

          if (value === null || value === undefined) {
            continue
          }

          title.push(`${this.$t(`${name}.label`)}: ${value}`)
        }

        return title.join(' | ')
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getErrorBySku'
      ])
    },
    components: {
      Panel,
      FormGroup,
      Container,
      Draggable,
      Checkbox,
      Multiselect,
      UploadFile,
      ProductProvideImage,
      Money
    }
  }
</script>

<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

  .c-box__body
    background: #d9edf7

  .c-box__heading
    cursor: pointer
    height: 50px
    line-height: 2
    font-size: 15px
    color: #31708f
    background-color: #d9edf7
    border-color: #bde2fb

  .icon-circle-down, .icon-circle-up
    font-size: 30px
</style>



// WEBPACK FOOTER //
// Variation.vue?00b0d65a